import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { Router } from '@angular/router';
import { SnotifyService } from 'ng-snotify';

@Component({
  selector: 'app-signup-master',
  templateUrl: './signup-master.component.html',
  styleUrls: ['./signup-master.component.css']
})
export class SignupMasterComponent implements OnInit {

  public form = {
    email: null,
    fullName: null,
    password: null,
    password_confirmation: null,
    idNo: null,
    totalVehicle: null,
    countryCode: null,
    mobile: null
  };
  public error: any = [];

  constructor(private User: UserService, private router: Router, private notify: SnotifyService) { }

  onSubmit() {
    if (!this.form.email || !this.form.fullName || !this.form.password
      || !this.form.totalVehicle || !this.form.countryCode || !this.form.mobile) {
      alert('Favor preencher todos os campos!');
      return false;
    }
    this.User.signupMaster(this.form).subscribe(
      data => this.handleResponse(data),
      error => this.handleError(error)
    );
  }

  handleResponse(data) {
    this.notify.success('Usuário cadastrado com sucesso.', {timeout: 2000, showProgressBar: false });
    this.router.navigateByUrl('/usuarios');
  }

  handleError(error) {
    this.error = error.error.error;
    this.notify.error(this.error, {timeout: 3000, showProgressBar: false });
  }

  ngOnInit() {
  }

}
